jQuery(document).ready(function ($) {

    $('.filter-toggle').on('click', function () {
        $('.ham-filter').addClass('active');
        $('.posts__filter').addClass('open');
        $('body').addClass('no-scroll');
    });

    // If an event gets to the body
    $(".posts__filter").click(function(){
        $('.ham-filter').removeClass('active');
        $(".posts__filter").removeClass('open');
        $('body').removeClass('no-scroll');
    });

    $('.close-filter').on('click', function () {
        $('.posts__filter').removeClass('open');
        $('.ham-filter').removeClass('active');
        $('body').removeClass('no-scroll');
    });

    // Prevent events from getting pass .popup
    $(".filter").on('click', function (e) {
        e.stopPropagation();
    });

    $('.search-icon').on('click', function () {
        $('.page-search').addClass('open');
        $('body').addClass('no-scroll');
        $("#search-site").focus();
    });

    $('.close-search-form').on('click', function () {
        $('.page-search').removeClass('open');
        $('body').removeClass('no-scroll');
    });
});